import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import { Collapse, Select, notification } from "antd";
import axios from "axios";
import { baseURL } from "./APIRepo";

import {
  MinusOutlined,
  DownloadOutlined,
  PlusOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
} from "@ant-design/icons";
import { Bar, Line } from "react-chartjs-2";
import "./raktkoshDashboard.css";

const { Panel } = Collapse;
const { Option } = Select;

const BloodCollection = forwardRef((props, ref) => {
  const [loading, setLoading] = useState(true);

  const [data, setData] = useState({});
  const scode = props.stateCode;
  console.log("State code from blood issue : ", scode);

  let [selectedDonorType, setSelectedDonorType] = useState("Camp Donor");

  const JwtTkn =
    "Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJEaGFpcnlhIn0.OCMcxEK6njp3J4SVfgV1HdDx3_-LiJ0QGaiqzfk1rbYFOIeCpm2A_2kcp1Pvn0iKMcrs0jZOOPDYGQN118z9ug";

  const fetchDataBloodIssue = async () => {
    console.log("api is getting hit from blood collections component");
    try {
      const headers = {
        Authorization: JwtTkn,
        "Content-Type": "application/json",
      };

      const now = new Date();
      const payload = {
        stateCode: scode,
        gdtMonth: (now.getMonth() + 1).toString(),
        gdtYear: now.getFullYear().toString(),
      };

      console.log("Fetch data called");

      const response = await axios.post(
        ` ${baseURL}/eRaktkoshUtilities/eraktkosh/bloodCollectionStats`,
        payload,
        { headers }
      );

      console.log("Response Data: ", response.data);

      setData(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDataBloodIssue(scode);
  }, [scode]);

  useImperativeHandle(ref, () => ({
    fetchDataBloodIssue,
  }));

  //***********************Donor Type wise******************************************************** */
  const donorType = data?.donorTypeWise?.[0] ?? {};
  const stateName = donorType?.statename ?? "";
  const totalVoluntaryColl = donorType?.totalVoluntaryColl ?? "";
  const totalReplacementColl = donorType?.totalReplacementColl ?? 0;
  const totalCampColl = donorType?.totalCampColl ?? 0;

  console.log("Total vol: ", totalVoluntaryColl);
  console.log("Total replc: ", totalReplacementColl);
  console.log("Total Camp col : ", totalReplacementColl);

  //************************* blood Group Wise district wise *********************************************************************/

  const bloodTypeWise = data?.bloodTypeWise?.[0] ?? {};
  const statename = bloodTypeWise?.statename ?? "";
  const districtName = bloodTypeWise?.districtName ?? "";
  const totalApos = bloodTypeWise?.totalApos ?? "";
  const totalBpos = bloodTypeWise?.totalBpos ?? "";
  const totalAneg = bloodTypeWise?.totalAneg ?? "";
  const totalBneg = bloodTypeWise?.totalBneg ?? "";
  const totalAbpos = bloodTypeWise?.totalAbpos ?? "";
  const totalAbneg = bloodTypeWise?.totalAbneg ?? "";
  const totalOpos = bloodTypeWise?.totalOpos ?? "";
  const totalOneg = bloodTypeWise?.totalOneg ?? "";
  const totalOhpos = bloodTypeWise?.totalOhpos ?? "";
  const totalOhneg = bloodTypeWise?.totalOhneg ?? "";

  console.log("district data ");

  //************************* blood Group Wise State wise *********************************************************************/

  const bloodTypeWiseState = data?.totalBloodGroupStats?.[0] ?? {};
  const statenameState = bloodTypeWiseState?.stateName ?? "";
  const districtNameState = bloodTypeWiseState?.districtName ?? "";
  const totalAposState = bloodTypeWiseState?.totalApos ?? "";
  const totalBposState = bloodTypeWiseState?.totalBpos ?? "";
  const totalAnegState = bloodTypeWiseState?.totalAneg ?? "";
  const totalBnegState = bloodTypeWiseState?.totalBneg ?? "";
  const totalAbposState = bloodTypeWiseState?.totalAbpos ?? "";
  const totalAbnegState = bloodTypeWiseState?.totalAbneg ?? "";
  const totalOposState = bloodTypeWiseState?.totalOpos ?? "";
  const totalOnegState = bloodTypeWiseState?.totalOneg ?? "";
  const totalOhposState = bloodTypeWiseState?.totalOhpos ?? "";
  const totalOhnegState = bloodTypeWiseState?.totalOhneg ?? "";

  //******************************* Trends Collection ******************************************************************************* */

  const donorTypeTrends = data?.totalDonorCollectionTrends?.[0] ?? {};
  const statedonorTypeTrends = donorTypeTrends?.stateName ?? "";
  const districtdonorTypeTrends = donorTypeTrends?.districtName ?? "";
  const totalVoluntaryCollTrendsdonor =
    donorTypeTrends?.totalVoluntaryColl ?? "";
  const totalReplacementCollTrendsdonor =
    donorTypeTrends?.totalReplacementColl ?? "";
  const totalCampCollTrendsdonor = donorTypeTrends?.totalCampColl ?? "";
  const gdtMonthDonorTrends = donorTypeTrends?.gdtMonth ?? "";

  //**********************Trends donor type wise**********************************/
  const donorTypeStats = data?.trendsDonorWise?.[0] ?? {};
  const TrendsStatenameTrends = donorTypeStats?.stateName ?? "";

  const TrendsDistrictnameTrends = donorTypeStats?.districtName ?? "";
  const totalVoluntaryCollTrends = donorTypeStats?.totalVoluntaryColl ?? "";
  const totalReplacementCollTrends = donorTypeStats?.totalReplacementColl ?? "";
  const totalCampCollTrends = donorTypeStats?.totalCampColl ?? "";
  const TrendsgdtMonth = donorTypeStats?.gdtMonth ?? "";

  //****************************Trends blood Group wise****************************************************/

  const groupwisestats = data?.trendsBloodWise?.[0] ?? {};
  const GroupwiseStatename = groupwisestats?.stateName ?? "";
  const GroupwiseDistrict = groupwisestats?.districtName ?? "";
  const GroupwisetotalApos = groupwisestats?.totalBpos ?? "";
  const GroupwisetotalBpos = groupwisestats?.totalBpos ?? "";
  const GroupwisetotalBneg = groupwisestats?.totalBneg ?? "";
  const GroupwisetotalAneg = groupwisestats?.totalAbneg ?? "";
  const GroupwisetotalAbpos = groupwisestats?.totalAbpos ?? "";
  const GroupwisetotalAbneg = groupwisestats?.totalAbneg ?? "";
  const GroupwisetotalOpos = groupwisestats?.totalOpos ?? "";
  const GroupwisetotalOneg = groupwisestats?.totalOneg ?? "";
  const GroupwisetotalOhpos = groupwisestats?.totalOhpos ?? "";
  const GroupwisetotalOhneg = groupwisestats?.totalOhneg ?? "";
  const GroupwiseGdtMonth = groupwisestats?.gdtMonth ?? "";

  //********************condtional variables**************************** */

  // const Trends

  const trendsCollection = data?.trendsCollection?.[0] ?? {};

  const [activeTab, setActiveTab] = useState("check"); // Default active tab is 'check'

  const accordionKeys = ["1", "2", "3"];
  const handleTabClick = (tabKey, e) => {
    e.stopPropagation();
    setActiveTab(tabKey);
  };

  //*************Donor Type wise******************* */

  const [selectedGroupType, setSelectedGroupType] = useState("");

  const [barChartDataH, setBarChartDataH] = useState({
    labels: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    datasets: [
      {
        label: "Trends Collection",
        data: new Array(12).fill(0),
        backgroundColor: "#A9A9A9",
        borderWidth: 0,
      },
    ],
  });

  // const districtNames = data?.trendsDonorWise?.map((item) => item.districtName) || [];

  const handleDonorGroup = (value) => {
    setSelectedGroupType(value);
  };

  const processData = (data, selectedDonorType, selectedGroupType) => {
    const monthsData = new Array(12).fill(0);

    if (selectedGroupType) {
      const trends = data.trendsDonorWise || [];

      trends.forEach((trend) => {
        if (trend.districtName === selectedGroupType) {
          const monthIndex = trend.gdtMonth - 1;
          if (monthIndex >= 0 && monthIndex < 12) {
            let value = 0;

            if (selectedDonorType === "Camp Donor") {
              value = trend.totalCampColl || 0;
            } else if (selectedDonorType === "Replacement") {
              value = trend.totalReplacementColl || 0;
            } else if (selectedDonorType === "Voluntary") {
              value = trend.totalVoluntaryColl || 0;
            }

            monthsData[monthIndex] = value;
          }
        }
      });
    } else {
      const trends = data.totalDonorCollectionTrends || [];

      trends.forEach((trend) => {
        const monthIndex = trend.gdtMonth - 1;
        if (monthIndex >= 0 && monthIndex < 12) {
          let value = 0;

          if (selectedDonorType === "Camp Donor") {
            value = trend.totalCampColl || 0;
          } else if (selectedDonorType === "Replacement") {
            value = trend.totalReplacementColl || 0;
          } else if (selectedDonorType === "Voluntary") {
            value = trend.totalVoluntaryColl || 0;
          }

          monthsData[monthIndex] = value;
        }
      });
    }

    return monthsData;
  };

  useEffect(() => {
    const updatedData = processData(data, selectedDonorType, selectedGroupType);
    setBarChartDataH((prev) => ({
      ...prev,
      datasets: [
        {
          ...prev.datasets[0],
          data: updatedData,
        },
      ],
    }));
  }, [data, selectedDonorType, selectedGroupType]);

  //************Blood group wise*************************** */

  const processBloodGroupData = (data, selectedGroupValue) => {
    const monthsData = new Array(12).fill(0);
    const trends = data.totalBloodGroupCollectionsTrends || [];

    // Define a mapping from blood group dropdown values to JSON keys
    const bloodGroupMapping = {
      "AB- ve": "totalAbneg",
      "AB+ ve": "totalAbpos",
      "A- ve": "totalAneg",
      "A+ ve": "totalApos",
      "B- ve": "totalBneg",
      "B+ ve": "totalBpos",
      "Oh- ve": "totalOhneg",
      "Oh+ ve": "totalOhpos",
      "O- ve": "totalOneg",
      "O+ ve": "totalOpos",
    };

    // Get the corresponding key for the selected blood group
    const bloodGroupKey = bloodGroupMapping[selectedGroupValue];

    if (!bloodGroupKey) {
      console.error(`Invalid blood group selected: ${selectedGroupValue}`);
      return monthsData; // Return empty data array if the selected group is invalid
    }

    trends.forEach((trend) => {
      const monthIndex = trend.gdtMonth - 1; // gdtMonth is 1-based index
      const value = trend[bloodGroupKey] || 0; // Default to 0 if undefined or null

      // Ensure monthIndex is within bounds and add to existing value
      if (monthIndex >= 0 && monthIndex < 12) {
        monthsData[monthIndex] += value;
      }
    });

    return monthsData;
  };

  const [selectedGroupvalue, setSelectedGroupValue] = useState("A+ ve");

  const [barChartDataHY, setBarChartDataHY] = useState({
    labels: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    datasets: [
      {
        label: "Trends Collection",
        data: new Array(12).fill(0),
        backgroundColor: "#A9A9A9",
        borderWidth: 0,
      },
    ],
  });

  const handleDistrictChange = (value) => {
    setSelectedGroupType(value);
  };

  const handleBloodGroupChange = (value) => {
    setSelectedGroupValue(value);
  };

  const processBloodGroupDataHY = (
    data,
    selectedGroupValue,
    selectedDistrict
  ) => {
    const monthsData = new Array(12).fill(0);
    const bloodGroupMapping = {
      "AB- ve": "totalAbneg",
      "AB+ ve": "totalAbpos",
      "A- ve": "totalAneg",
      "A+ ve": "totalApos",
      "B- ve": "totalBneg",
      "B+ ve": "totalBpos",
      "Oh- ve": "totalOhneg",
      "Oh+ ve": "totalOhpos",
      "O- ve": "totalOneg",
      "O+ ve": "totalOpos",
    };

    const bloodGroupKey = bloodGroupMapping[selectedGroupValue];

    if (!bloodGroupKey) {
      console.error(`Invalid blood group selected: ${selectedGroupValue}`);
      return monthsData;
    }

    const trends = selectedDistrict
      ? data.trendsBloodWise
      : data.totalBloodGroupCollectionsTrends;

    if (!Array.isArray(trends)) {
      console.error(`Trends data is not an array`);
      return monthsData;
    }

    trends.forEach((trend) => {
      if (!selectedDistrict || trend.districtName === selectedDistrict) {
        const monthIndex = trend.gdtMonth - 1;
        const value = trend[bloodGroupKey] || 0;

        if (monthIndex >= 0 && monthIndex < 12) {
          monthsData[monthIndex] += value;
        }
      }
    });

    return monthsData;
  };

  useEffect(() => {
    const updatedBloodGroupData = processBloodGroupDataHY(
      data,
      selectedGroupvalue,
      selectedGroupType
    );
    setBarChartDataHY((prev) => ({
      ...prev,
      datasets: [
        {
          ...prev.datasets[0],
          data: updatedBloodGroupData,
        },
      ],
    }));
  }, [data, selectedGroupvalue, selectedGroupType]);

  //******************************Donor Group Wise**************************************** */

  // const [selectedGroupType, setSelectedGroupType] = useState('');

  const selectData = ["Camp Donor", "Replacement", "Voluntary"];

  const selectDataBloodGroup = [
    "AB- ve",
    "AB+ ve",
    "A- ve",
    "A+ ve",
    "B- ve",
    "B+ ve",
    "Oh- ve",
    "Oh+ ve",
    "O- ve",
    "O+ ve",
  ];

  const handleChangeGroup = (value) => {
    setSelectedGroupValue(value);
    console.log("Selected value:", value);
  };

  console.log("Blood group selected is : ", selectedGroupvalue);

  const distname = data?.bloodTypeWise?.[0] ?? districtName;

  console.log("district name custom : ", distname);

  const selectDataTrends = ["2024"];

  const handleDonorTypeChange = (value) => {
    setSelectedDonorType(value);

    console.log("Selected value is", value);
  };

  useEffect(() => {
    setSelectedGroupType(undefined);
  }, [scode]);

  const handleDonorTypeChangeGroup = (value1) => {
    setSelectedGroupType(value1);
    console.log("Selected value is", value1);
  };

  console.log(
    " selected district : ",
    typeof selectedGroupType,
    selectedGroupType
  );

  const [sortConfigDonorType, setSortConfigDonorType] = useState({
    key: "count",
    direction: "desc",
  });
  const [sortConfigBloodType, setSortConfigBloodType] = useState({
    key: "count",
    direction: "desc",
  });
  const [activeSortDonorType, setActiveSortDonorType] = useState({
    key: "",
    direction: "",
  });
  const [activeSortBloodType, setActiveSortBloodType] = useState({
    key: "",
    direction: "",
  });

  const handleSortDonorType = (key) => {
    let direction = "asc";
    if (
      sortConfigDonorType.key === key &&
      sortConfigDonorType.direction === "asc"
    ) {
      direction = "desc";
    }
    setSortConfigDonorType({ key, direction });
    setActiveSortDonorType({ key, direction });
  };

  const handleSortBloodType = (key) => {
    let direction = "asc";
    if (
      sortConfigBloodType.key === key &&
      sortConfigBloodType.direction === "asc"
    ) {
      direction = "desc";
    }
    setSortConfigBloodType({ key, direction });
    setActiveSortBloodType({ key, direction });
  };

  const stateNames = [];
  const districtNames = [];
  const bloodCentresData = [];

  data?.donorTypeWise?.forEach((stat) => {
    if (scode === 0) {
      stateNames.push(stat.stateName);
      bloodCentresData.push(
        selectedDonorType === "Camp Donor"
          ? stat.totalCampColl || 0
          : selectedDonorType === "Replacement"
          ? stat.totalReplacementColl || 0
          : stat.totalVoluntaryColl || 0
      );
    } else {
      districtNames.push(stat.districtName);
      bloodCentresData.push(
        selectedDonorType === "Camp Donor"
          ? stat.totalCampColl || 0
          : selectedDonorType === "Replacement"
          ? stat.totalReplacementColl || 0
          : stat.totalVoluntaryColl || 0
      );
    }
  });

  useEffect(() => {
    fetchDataBloodIssue();
  }, [selectedDonorType, scode]);

  const labels = scode === 0 ? stateNames : districtNames;

  const getDistrictData = (districtName) => {
    return data.bloodTypeWise.find(
      (district) => district.districtName === districtName
    );
  };

  let VariableStateDist;
  if (scode !== 0 && selectedGroupType) {
    const districtData = getDistrictData(selectedGroupType);
    VariableStateDist = districtData
      ? [
          districtData.totalApos,
          districtData.totalBpos,
          districtData.totalAneg,
          districtData.totalBneg,
          districtData.totalAbpos,
          districtData.totalAbneg,
          districtData.totalOpos,
          districtData.totalOneg,
          districtData.totalOhpos,
          districtData.totalOhneg,
        ]
      : [];
  } else {
    VariableStateDist = [
      totalAposState,
      totalBposState,
      totalAnegState,
      totalBnegState,
      totalAbposState,
      totalAbnegState,
      totalOposState,
      totalOnegState,
      totalOhposState,
      totalOhnegState,
    ];
  }

  // Sort Donor Type Wise Data
  const sortedDataDonorType = useMemo(() => {
    const sortableItems = labels.map((label, index) => ({
      label,
      value: bloodCentresData[index],
    }));

    sortableItems.sort((a, b) => {
      if (sortConfigDonorType.key === "count") {
        return sortConfigDonorType.direction === "asc"
          ? a.value - b.value
          : b.value - a.value;
      } else if (sortConfigDonorType.key === "state") {
        return sortConfigDonorType.direction === "asc"
          ? a.label.localeCompare(b.label)
          : b.label.localeCompare(a.label);
      }
      return 0;
    });

    return {
      labels: sortableItems.map((item) => item.label),
      data: sortableItems.map((item) => item.value),
    };
  }, [bloodCentresData, labels, sortConfigDonorType]);

  // Sort Blood Type Wise Data
  const sortedDataBloodType = useMemo(() => {
    const sortableItems = VariableStateDist.map((value, index) => ({
      label: ["A+", "B+", "A-", "B-", "AB+", "AB-", "O+", "O-", "Oh+", "Oh-"][
        index
      ],
      value,
    }));

    sortableItems.sort((a, b) => {
      if (sortConfigBloodType.key === "count") {
        return sortConfigBloodType.direction === "asc"
          ? a.value - b.value
          : b.value - a.value;
      } else if (sortConfigBloodType.key === "state") {
        return sortConfigBloodType.direction === "asc"
          ? a.label.localeCompare(b.label)
          : b.label.localeCompare(a.label);
      }
      return 0;
    });

    return {
      labels: sortableItems.map((item) => item.label),
      data: sortableItems.map((item) => item.value),
    };
  }, [VariableStateDist, sortConfigBloodType]);

  const barChartData = {
    labels: sortedDataDonorType.labels,
    datasets: [
      {
        label: "Donor Type Wise Data",
        data: sortedDataDonorType.data,
        backgroundColor: "#50C0FF",
        borderWidth: 0,
      },
    ],
  };

  const barChartDatabloodTypeWise = {
    labels: sortedDataBloodType.labels,
    datasets: [
      {
        label: "Group Wise Blood Collected",
        data: sortedDataBloodType.data,
        backgroundColor: "#50C0FF",
        borderWidth: 0,
      },
    ],
  };

  const labelsCount = barChartData.labels.length;
  const baseHeightDonor = labelsCount < 10 ? 50 : labelsCount < 20 ? 50 : 50;
  const heightPerDataPointDonor = 25;
  const minHeightDonor = 100;

  let requiredHeightDonor =
    baseHeightDonor + labelsCount * heightPerDataPointDonor;

  if (labelsCount < 3) {
    requiredHeightDonor = minHeightDonor;
  }

  //******************************************************************************* */

  const districtNamesGrp = [];
  const bloodCentresDataGrp = [];
  const stateNamesGrp = [];

  data?.bloodTypeWise?.forEach((stat) => {
    if (scode === 0) {
      stateNamesGrp.push(stat.statename);
    } else {
      districtNamesGrp.push(stat.districtName);
    }

    bloodCentresDataGrp.push(
      totalApos +
        totalBpos +
        totalAneg +
        totalBneg +
        totalAbpos +
        totalAbneg +
        totalOpos +
        totalOneg +
        totalOhpos +
        totalOhneg
    );
  });

  useEffect(() => {
    fetchDataBloodIssue();
  }, [scode]);

  console.log(stateNamesGrp, districtNamesGrp, bloodCentresDataGrp);

  // const labelsGrp = scode === 0 ? stateNamesGrp : districtNamesGrp;

  const numLabels = barChartData.labels.length;
  const maxChartHeight = 50 + numLabels * 30; // Adjust 50 and 30 as needed for padding and label height
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: "y",
    scales: {
      x: {
        grid: {
          display: false,
        },
      },

      y: {
        grid: {
          display: false,
        },
        min: 0,
        max: 100,
        ticks: {
          beginAtZero: true,
          stepSize: 50,
          autoSkip: false,
          font: {
            size: 12,
          },
        },
        display: true,
        position: "left",
      },
    },
    barThickness: 10,
    plugins: {
      datalabels: {
        color: "#71797E",
        anchor: "end",
        align: "end",
        formatter: (value, context) => `${value}`,
        font: {
          size: "10px",
          weight: "bold",
        },
      },
      legend: {
        display: false,
      },
    },
    layout: {
      padding: {
        right: 80,
        left: 50,
      },
    },
    maxHeight: maxChartHeight,
    datasets: {
      bar: {
        barPercentage: 0.9,
        categoryPercentage: 1,
      },
    },
  };

  const optionsH = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        grid: {
          display: false,
        },
      },

      y: {
        beginAtZero: true,
        autoSkip: false,
        grid: {
          display: false,
        },
      },
    },
    datasets: {
      bar: {
        barPercentage: 0.7, // Adjust the thickness of the bars
        categoryPercentage: 0.6, // Adjust the spacing between the bars
      },
    },
    plugins: {
      legend: {
        display: false, // Hide legend
      },
    },
  };

  //************************************************************************************************************ */

  const lineChartData = {
    labels: ["January", "February", "March", "April", "May", "June", "July"],
    datasets: [
      {
        label: "Line 1",
        data: [65, 59, 80, 81, 56, 55, 40],
        fill: false,
        borderColor: "#0275FF",
        tension: 0.1,
      },
      {
        label: "Line 2",
        data: [35, 40, 60, 70, 45, 65, 50],
        fill: false,
        borderColor: "#FF9800",
        tension: 0.1,
      },
    ],
  };

  // Options for line chart
  const lineChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top", // Position the legend to the right of the chart
        align: "end",
        labels: {
          boxWidth: 16,
          boxHeight: 1,
          font: {
            size: 10,
            weight: "bold",
          },
        },
      },
    },
  };

  const isDisabled = scode === 0;

  const selectStyle = {
    borderRadius: "7px",
    width: 214,
    marginLeft: "auto",
    backgroundColor: isDisabled ? "rgb(219 214 214)" : "#fff",
  };

  return (
    <div>
      <div className="d-flex flex-column">
        <div className="d-flex flex-column" id="checkID">
          <div style={{ display: "flex" }}>
            <p className="stats mb-1">Blood Collection</p>

            {activeTab === "check" ? (
              <div></div>
            ) : (
              <div
                className="stats mb-1"
                style={{ marginLeft: "auto", fontWeight: "normal" }}
              >
                {" "}
                <Select
                  style={selectStyle}
                  title="Select District"
                  placeholder="Select District"
                  value={selectedGroupType} // Add this line to control the select value
                  onChange={handleDonorTypeChangeGroup}
                  onClick={(e) => e.stopPropagation()}
                  disabled={scode === 0}
                >
                  {districtNames.map((district, index) => (
                    <Option key={index} value={district}>
                      {district}
                    </Option>
                  ))}
                </Select>
              </div>
            )}
          </div>

          <div className="d-flex gap-3 mb-4">
            <div className="col-12">
              <Collapse
                expandIconPosition="right"
                expandIcon={({ isActive }) =>
                  isActive ? <MinusOutlined /> : <PlusOutlined />
                }
                className="accodianHeader"
                defaultActiveKey={accordionKeys}
              >
                <Panel
                  header={
                    <div className="d-flex" aria-expanded="true">
                      <span
                        className={`d-flex bloodcollectiontabs${
                          activeTab === "check" ? " active" : ""
                        }`}
                        onClick={(e) => handleTabClick("check", e)}
                      >
                        Donor Type Wise
                        <DownloadOutlined />
                      </span>

                      <span
                        className={`d-flex bloodcollectiontabs${
                          activeTab === "check2" ? " active" : ""
                        }`}
                        onClick={(e) => handleTabClick("check2", e)}
                      >
                        Blood Group Wise
                        <DownloadOutlined />
                      </span>

                      {activeTab === "check" ? (
                        <Select
                          title="Select Donor Type"
                          style={{ width: 214, marginLeft: "auto" }}
                          placeholder="Camp Donor"
                          // defaultValue={["Camp Donor"]}

                          onChange={handleDonorTypeChange}
                          onClick={(e) => e.stopPropagation()}
                        >
                          {selectData.map((selectDatas, index) => (
                            <Option key={index} value={selectDatas}>
                              {selectDatas}
                            </Option>
                          ))}
                        </Select>
                      ) : (
                        <> </>
                      )}
                    </div>
                  }
                  key="1"
                >
                  <div className="chartScrollBody">
                    <div style={{ height: "300px" }}>
                      {activeTab === "check" ? (
                        <div>
                          <div style={{ height: `${requiredHeightDonor}px` }}>
                            <div style={{ height: `${requiredHeightDonor}px` }}>
                              <Bar
                                data={barChartData}
                                options={options}
                                style={{ width: "50%", height: "100%" }}
                              />
                            </div>
                          </div>
                        </div>
                      ) : (
                        <Bar
                          data={barChartDatabloodTypeWise}
                          options={options}
                          style={{ width: "50%", height: "100%" }}
                        />
                      )}
                    </div>
                  </div>

                  <div>
                    {activeTab === "check" ? (
                      <div>
                        <p className="mb-0 d-flex gap-3 align-items-center justify-content-end filtersbtn">
                          <span onClick={() => handleSortDonorType("count")}>
                            Count
                            <ArrowUpOutlined
                              style={{
                                color:
                                  activeSortDonorType.key === "count" &&
                                  activeSortDonorType.direction === "asc"
                                    ? "blue"
                                    : "inherit",
                                cursor: "pointer",
                                fontWeight: "bolder",
                              }}
                            />
                            <ArrowDownOutlined
                              style={{
                                color:
                                  activeSortDonorType.key === "count" &&
                                  activeSortDonorType.direction === "desc"
                                    ? "blue"
                                    : "inherit",
                                cursor: "pointer",
                              }}
                            />
                          </span>
                          <span onClick={() => handleSortDonorType("state")}>
                            {scode === 0 ? "State" : "District"}
                            <ArrowUpOutlined
                              style={{
                                color:
                                  activeSortDonorType.key === "state" &&
                                  activeSortDonorType.direction === "asc"
                                    ? "blue"
                                    : "inherit",
                                cursor: "pointer",
                              }}
                            />
                            <ArrowDownOutlined
                              style={{
                                color:
                                  activeSortDonorType.key === "state" &&
                                  activeSortDonorType.direction === "desc"
                                    ? "blue"
                                    : "inherit",
                                cursor: "pointer",
                              }}
                            />
                          </span>
                        </p>
                      </div>
                    ) : (
                      <div>
                        <p className="mb-0 d-flex gap-3 align-items-center justify-content-end filtersbtn">
                          <span onClick={() => handleSortBloodType("count")}>
                            Count
                            <ArrowUpOutlined
                              style={{
                                color:
                                  activeSortBloodType.key === "count" &&
                                  activeSortBloodType.direction === "asc"
                                    ? "blue"
                                    : "inherit",
                                cursor: "pointer",
                                fontWeight: "600",
                              }}
                            />
                            <ArrowDownOutlined
                              style={{
                                color:
                                  activeSortBloodType.key === "count" &&
                                  activeSortBloodType.direction === "desc"
                                    ? "blue"
                                    : "inherit",
                                cursor: "pointer",
                                fontWeight: "600",
                              }}
                            />
                          </span>
                        </p>
                      </div>
                    )}
                  </div>
                </Panel>
              </Collapse>
            </div>
          </div>
        </div>
        <div>
          <div className="row blood">
            <div className="col-6 bloodc">
              <Collapse
                expandIconPosition="right"
                expandIcon={({ isActive }) =>
                  isActive ? <MinusOutlined /> : <PlusOutlined />
                }
                defaultActiveKey={accordionKeys}
                className="accodianHeader"
              >
                <Panel
                  header={
                    <span className="d-flex justify-content-between align-items-center stastHeaderTitlte">
                      {" "}
                      Trends Collection{" "}
                      <div style={{ display: "flex" }}>
                        {activeTab === "check" ? (
                          <div style={{ display: "flex" }}>
                            <Select
                              style={selectStyle}
                              title="Select District"
                              placeholder="Select District"
                              value={selectedGroupType}
                              onChange={handleDonorGroup}
                              onClick={(e) => e.stopPropagation()}
                              disabled={scode === 0}
                            >
                              {districtNames.map((district, index) => (
                                <Option key={index} value={district}>
                                  {district}
                                </Option>
                              ))}
                            </Select>
                            &nbsp;&nbsp;
                            <Select
                              style={{ width: 214 }}
                              placeholder="select status"
                              defaultValue={["Select Year"]}
                              onClick={(e) => e.stopPropagation()}
                            >
                              {selectDataTrends.map((selectDatas, index) => {
                                return (
                                  <Select.Option
                                    key={index}
                                    value={selectDatas}
                                  ></Select.Option>
                                );
                              })}
                            </Select>
                          </div>
                        ) : (
                          <div
                            className="stats mb-1"
                            style={{ marginLeft: "auto", fontWeight: "normal" }}
                          >
                            {" "}
                            <Select
                              style={selectStyle}
                              title="Select Blood Group"
                              placeholder="Select Blood Group"
                              defaultValue={"A+ ve"}
                              onClick={(e) => e.stopPropagation()}
                              onChange={handleChangeGroup}
                            >
                              {selectDataBloodGroup.map(
                                (selectDatag, index) => (
                                  <Option key={index} value={selectDatag}>
                                    {selectDatag}
                                  </Option>
                                )
                              )}
                            </Select>
                            &nbsp;&nbsp;
                            <Select
                              style={{ width: 214 }}
                              placeholder="select status"
                              defaultValue={["Select Year"]}
                              onClick={(e) => e.stopPropagation()}
                            >
                              {selectDataTrends.map((selectDatas, index) => {
                                return (
                                  <Select.Option
                                    key={index}
                                    value={selectDatas}
                                  ></Select.Option>
                                );
                              })}
                            </Select>
                          </div>
                        )}
                        &nbsp;&nbsp;{" "}
                        <DownloadOutlined
                          onClick={(e) => e.stopPropagation()}
                        />
                      </div>
                    </span>
                  }
                  key="2"
                >
                  <div className="chartScrollBodyNew">
                    <div style={{ height: "280px" }}>
                      {activeTab === "check" ? (
                        <Bar
                          data={barChartDataH}
                          options={optionsH}
                          style={{ width: "100%", height: "100%" }}
                        />
                      ) : (
                        <>
                          <Bar
                            data={barChartDataHY}
                            options={optionsH}
                            style={{ width: "100%", height: "100%" }}
                          />
                        </>
                      )}
                    </div>
                  </div>
                </Panel>
              </Collapse>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default BloodCollection;
